import { graphql } from "gql.tada";
import { LinkFragment } from "../fragments/LinkFragment";

export const InsightsBlockFragment = graphql(
  `
    fragment InsightsBlockFragment on InsightsBlocks {
      variant
      icon {
        url
      }
      category
      extraInfoLabel
      shortHighlightedValue
      mainText
      subText
      readMoreLink {
        ...LinkFragment
      }
      bottomText
      backgroundImage {
        url
      }
    }
  `,
  [LinkFragment]
);
